export var SiteId;
(function (SiteId) {
    SiteId["GoodLifePlus"] = "a78bc32f-3641-4ef6-8cf5-ee949e257740";
    SiteId["Rangers"] = "0d9f0ba9-a416-4622-b03b-44aaae2ceff1";
    SiteId["Saints"] = "89cc8174-0b56-4f37-9e55-d002873dcf08";
    SiteId["Lions"] = "9694474e-95c2-4173-89ae-78c8c854e0ff";
})(SiteId || (SiteId = {}));
export var ThemeType;
(function (ThemeType) {
    ThemeType["Default"] = "default";
    ThemeType["Club"] = "club";
})(ThemeType || (ThemeType = {}));
